import React, {Component} from 'react';

import ReadyButton from '../../components/ReadyButton';
import AudioPlayer from '../../components/AudioPlayer';

import se_workingMemoryNumbersIntro from '../../assets/sounds/se/intros/workingmemory-numbers-intro.mp3';
import strings from '../../strings';

class Intro extends Component {
	constructor(props) {
		super(props);
		switch (strings.getLanguage()) {
			case 'se':
				this.audio = se_workingMemoryNumbersIntro;
				break;
			default:
				this.audio = se_workingMemoryNumbersIntro;
				break;
		}
	}

	render() {
		return (
			<>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{strings.wsn_intro1}
					<br />
					{strings.wsn_intro2}
					<br />
					{strings.wsn_intro3}
				</p>
				<ReadyButton onReadyChange={this.props.setReady} />
			</>
		);
	}
}

export default Intro;
